import Dexie, { type EntityTable, type Table } from "dexie";
import type { Brand, CacheMetadata, ColumnInDB, Option, OptionGroup, UiField, UiTable } from "./types";

const dexie = new Dexie("JasiDatabase") as Dexie & {
  optionGroups: EntityTable<OptionGroup, "id">;
  options: Table<Option>;
  brands: EntityTable<Brand, "id">;
  uiTables: Table<UiTable>;
  uiFields: Table<UiField>;
  columnsInDB: Table<ColumnInDB>;
  cacheMetadata: EntityTable<CacheMetadata, "key">;
};

const stores = {
  optionGroups: "id",
  options: "[id+optionGroupId], optionGroupId",
  brands: "id",
  uiTables: "[schemaName+tableName]",
  uiFields: "[schemaName+tableName+fieldName], [schemaName+tableName], optionGroupId, sectionId",
  columnsInDB: "[schemaName+tableName+fieldName], [schemaName+tableName]",
};

dexie.version(1).stores(stores);
dexie.version(2).stores({ ...stores, cacheMetadata: "key" });

export { dexie };
